import { OK } from 'http-status-codes'
import getAxiosInstance from '../../helpers/get_axios_instance'

class CamionesCalados {
  static getCamionesCalados () {
    const orden = '{"orden": ["d:fecha_de_calado"]}'
    const axios = getAxiosInstance()
    const promise = axios.get(`/consulta_calado_aceptado_listado?r=${orden}`)
    return promise.then((result) => {
      const { status, data } = result
      if (status !== OK) throw new Error('No se pudo obtener el listado de camiones calados.')
      return data
    })
  };
}

export default CamionesCalados
